import { Login } from "@rewardle/apps.ui.login.login";
import { Unauthorisedlayout } from "@rewardle/apps.auth.unauthorisedlayout.unauthorisedlayout";
import { Forgotpassword } from "@rewardle/apps.ui.forgotpassword.forgotpassword";
import Dashboard from "./pages/Dashboard";
import { Navigate } from "react-router-dom";

const actionCodeSettings = {
  url: `${process.env.REACT_APP_API_URL}`,
  handleCodeInApp: true,
  dynamicLinkDomain: process.env.REACT_APP_DYNAMIC_LINK_DOMAIN
};

export const authedRoutes = [
  {
    path: "/",
    element: <Navigate to="/merchant" replace />
  },
  {
    path: "/merchant",
    element: <Dashboard />
  }
];

export const unAuthedRoutes = [
  {
    path: "/",
    element: <Login authorizationName={"BusinessAuthorization"} />
  },
  {
    path: "forgot-password",
    element: (
      <Forgotpassword
        actionCodeSettings={actionCodeSettings}
        authorizationName={"BusinessAuthorization"}
      />
    )
  },
  {
    path: "login",
    element: <Login authorizationName={"BusinessAuthorization"} />
  }
];

export const unAuthorisedlayout = [
  {
    path: "/",
    element: <Unauthorisedlayout />
  },
  {
    path: "unauthorised",
    element: <Unauthorisedlayout />
  }
];
